module.exports = __webpack_public_path__ + "static/media/Lixeira.315f2326.svg";